import { IMenuOption } from "@/services/DTOs/Misc";
import { PermissionCategory } from "@/services/DTOs/Permission";

export default [
  {
    text: "Comment threads",
    to: "/linkedin/comment-threads",
    icon: "mdi-comment-multiple-outline",
    desc: "Review and reply to LinkedIn comment threads",
    permissions: [
      {
        name: "linkedin.comment-threads",
        category: PermissionCategory.PAGE
      }
    ]
  }
] as IMenuOption[];
